<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    class="solvit-back-arrow-icon"
    :class="{ 'solvit-back-arrow-icon--explicit': Boolean(color) }"
    :fill="fillValue"
  >
    <g id="_74_flip-backward" data-name="74 flip-backward">
      <path
        d="M9.29,19.71,4,14.41a2,2,0,0,1,0-2.82l5.29-5.3,1.42,1.42L5.41,13l5.3,5.29Z"
      />
      <path
        d="M19.5,24H16V22h3.5a4,4,0,0,0,0-8H4.41V12H19.5a6,6,0,0,1,0,12Z"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'BackArrowIcon',
  props: {
    /** 비우면 테마 텍스트(--v-text-base) / 다크는 밝은 글자 — 라이트에서 흰색 고정 비권장 */
    color: {
      type: String,
      default: ''
    }
  },
  computed: {
    fillValue() {
      return this.color || 'currentColor';
    }
  }
};
</script>

<style scoped>
/* theme 기본: 라이트/다크 모두 --v-text-base — 명시 color prop 시 fill만 해당 값 */
.solvit-back-arrow-icon:not(.solvit-back-arrow-icon--explicit) {
  color: var(--v-text-base, currentColor);
}
</style>
